import React, { useState } from 'react';
import { useQuery } from 'react-query';
import {
  CountTitle,
  DashboardCard,
  DashboardCardContainer,
  DashboardContainer,
  DashboardContainerLeft,
  DashboardContainerRight,
  DashboardContainerRightTitle,
  DashboardCountCard,
  DashboardCountCardLeft,
  DashboardCountCardRight,
  DashboardCountContainer,
  DashboardCountContainerLeft,
  DashboardCountContainerRight,
  DashboardCountView,
  DashboardHeaderContainer,
  DashboardHeaderTitle,
  DashboardTableContainer,
  DashboardTableView,
  LabelCount,
  LinksWrapper,
  LogoContainer,
  LogoImage,
  LogoTitle,
  LogoWrapper,
} from './dashboard.style';
import AppsIcon from '@mui/icons-material/Apps';
import {
  BellIcon,
  DairyAustraliaLogo,
  GeolocationSvg,
  LogrecordSvg,
  PremiseSvg,
  SosIcon,
  UserSvg,
  VideoCamSvg,
} from '../../../Components/icons';
import { Label } from '../../../Components/uielements';
import DashboardTable from './table/dashboardTable';
import { useUserContext } from '../../../hooks/UserContext';
import * as UserService from '../../../services/bioplus-services/user';
import CompanyService from '../../../services/bioplus-services/company';
import PremiseService from '../../../services/bioplus-services/premise';
import GeofenceService from '../../../services/bioplus-services/geofence';
import LogBookService from '../../../services/bioplus-services/logBook';
// import { notificationCountByPartner } from '../../../services/bioplus-services/notifications';
import { useCompany } from '../../../hooks/CompanyContext';
import DateUtils from '../../../utils/date-utils';
import { openLinkInNewTab } from './helper';
import MLALogo from '../../../assets/PNG/mla.png';
import GovOfSouthAustraliaLogo from '../../../assets/PNG/gov_of_south_aus.png';
import AgricultureAustraliaLogo from '../../../assets/PNG/agricultureAus.png';
import { IntlMessages } from '../../../helper/langHelper';
import { LinksModal } from './modals/linksModal';

const CorporateDashboard = () => {
  const userContext = useUserContext();
  const companyContext = useCompany();
  const [isShowLinksModal, setIsShowLinksModal] = useState(false);
  const parentId = userContext.company?.companyId?.id;
  const companyFilter = companyContext?.company?._id;
  const companyCountQuery = useQuery(['companyCount', companyFilter], () =>
    CompanyService.countByParent(parentId, { companyId: companyFilter })
  );
  const userCountQuery = useQuery(['userCount', companyFilter], () =>
    UserService.countByParent(parentId, { companyId: companyFilter })
  );
  const premiseCountQuery = useQuery(['premiseCount', companyFilter], () =>
    PremiseService.countByParent(parentId, { companyId: companyFilter })
  );
  const geofenceCountQuery = useQuery(['geofenceCount', companyFilter], () =>
    GeofenceService.countByParent(parentId, { companyId: companyFilter })
  );
  const logRecordCountQuery = useQuery(['logBookCount', companyFilter], () =>
    LogBookService.countByParent(parentId, { companyId: companyFilter })
  );

  const query = useQuery(['logBookEntries'], () =>
    LogBookService.listByParent(
      parentId,
      {
        companyId: companyFilter,
        fromDate: DateUtils.last7Days(),
        toDate: DateUtils.today(),
      },
      0,
      5
    )
  );
  const tableData = query?.data?.items ?? [];

  return (
    <DashboardContainer>
      {/* hearder section */}
      <DashboardHeaderContainer>
        <AppsIcon />
        <DashboardHeaderTitle>
          <IntlMessages id="nav.dashboard" />
        </DashboardHeaderTitle>
      </DashboardHeaderContainer>
      {/* card section */}
      <DashboardCardContainer>
        <DashboardContainerLeft>
          <DashboardCard>
            <LogoContainer>
              <LogoTitle>Camera 1</LogoTitle>
              <VideoCamSvg />
            </LogoContainer>
          </DashboardCard>
          <DashboardCard>
            <LogoContainer>
              <LogoTitle>Camera 2</LogoTitle>
              <VideoCamSvg />
            </LogoContainer>
          </DashboardCard>
          <DashboardCard>
            <LogoContainer>
              <LogoTitle>Camera 3</LogoTitle>
              <VideoCamSvg />
            </LogoContainer>
          </DashboardCard>
          <DashboardCard>
            <LogoContainer>
              <LogoTitle>Camera 4</LogoTitle>
              <VideoCamSvg />
            </LogoContainer>
          </DashboardCard>
        </DashboardContainerLeft>
        <DashboardContainerRight>
          <DashboardContainerRightTitle>
            <IntlMessages id="dashboard.links" />
          </DashboardContainerRightTitle>
          <LinksWrapper>
            <LogoWrapper onClick={() => openLinkInNewTab('https://www.mla.com.au/')}>
              <LogoImage src={MLALogo} alt="mla.logo" />
            </LogoWrapper>
            <LogoWrapper onClick={() => openLinkInNewTab('https://pir.sa.gov.au/')}>
              <LogoImage src={GovOfSouthAustraliaLogo} alt="govofsouthaustralia.logo" />
            </LogoWrapper>
            <LogoWrapper onClick={() => openLinkInNewTab('https://agriculture.vic.gov.au/')}>
              <LogoImage src={AgricultureAustraliaLogo} alt="AgricultureAustraliaLogo.logo" />
            </LogoWrapper>
            <LogoWrapper onClick={() => openLinkInNewTab('https://www.dairyaustralia.com.au/')}>
              <DairyAustraliaLogo />
            </LogoWrapper>{' '}
            <Label
              color="primary"
              cursor="pointer"
              style={{ fontSize: '16px' }}
              onClick={() => setIsShowLinksModal(true)}
            >
              <IntlMessages id="links.button.label" />
            </Label>
          </LinksWrapper>
        </DashboardContainerRight>
      </DashboardCardContainer>
      {/* table view */}
      <DashboardTableContainer>
        <DashboardTableView>
          <Label weight="bold" size="header1">
            <IntlMessages id="dashboard.visitors" />
          </Label>
          <DashboardTable data={tableData} />
        </DashboardTableView>
        <DashboardCountView>
          <Label weight="bold" size="header1">
            <IntlMessages id="dashboard.counts" />
          </Label>
          <DashboardCountContainer>
            <DashboardCountContainerRight>
              <DashboardCountCard>
                <DashboardCountCardLeft>
                  <PremiseSvg />
                  <CountTitle>
                    <IntlMessages id="nav.companies" />
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <LabelCount>{companyCountQuery.data ?? 0}</LabelCount>
                </DashboardCountCardRight>
              </DashboardCountCard>
              <DashboardCountCard>
                <DashboardCountCardLeft>
                  <UserSvg />
                  <CountTitle>
                    <IntlMessages id="nav.users" />
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <LabelCount>{userCountQuery?.data ?? 0}</LabelCount>
                </DashboardCountCardRight>
              </DashboardCountCard>{' '}
              <DashboardCountCard>
                <DashboardCountCardLeft>
                  <PremiseSvg />
                  <CountTitle>
                    <IntlMessages id="nav.premises" />
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <LabelCount>{premiseCountQuery?.data ?? 0}</LabelCount>
                </DashboardCountCardRight>
              </DashboardCountCard>
              <DashboardCountCard>
                <DashboardCountCardLeft>
                  <GeolocationSvg />
                  <CountTitle>
                    <IntlMessages id="nav.geofences" />
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <LabelCount>{geofenceCountQuery?.data ?? 0}</LabelCount>
                </DashboardCountCardRight>
              </DashboardCountCard>
            </DashboardCountContainerRight>
            <DashboardCountContainerLeft>
              <DashboardCountCard>
                <DashboardCountCardLeft>
                  <LogrecordSvg />
                  <CountTitle>
                    <IntlMessages id="nav.records.logRecords" />
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <LabelCount>{logRecordCountQuery?.data ?? 0}</LabelCount>
                </DashboardCountCardRight>
              </DashboardCountCard>
              <DashboardCountCard>
                <DashboardCountCardLeft>
                  <BellIcon />
                  <CountTitle>
                    <IntlMessages id="nav.records.notifications" />
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <LabelCount>0</LabelCount>
                </DashboardCountCardRight>
              </DashboardCountCard>
              <DashboardCountCard>
                <DashboardCountCardLeft>
                  <SosIcon />
                  <CountTitle>
                    <IntlMessages id="nav.records.sos" />
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <LabelCount>0</LabelCount>
                </DashboardCountCardRight>
              </DashboardCountCard>
            </DashboardCountContainerLeft>
          </DashboardCountContainer>
        </DashboardCountView>
      </DashboardTableContainer>
      {isShowLinksModal && <LinksModal onClose={() => setIsShowLinksModal(false)} />}
    </DashboardContainer>
  );
};

export default CorporateDashboard;
